import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FiArrowUpRight, FiArrowDown, FiHelpCircle, FiArrowUpLeft } from 'react-icons/fi';
import '../../../components/HelpModal/HelpModal.css';

function FechamentoViewHelpModal() {
    const [show, setShow] = useState(false);
    const [isSteps, setIsSteps] = useState(1);

    const handleClose = () => {
        setIsSteps(1);
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const getStepsView = (step) => {
        switch (step) {
            case 1: return (
                <Modal.Body>
                    <p className="description-text-info">
                        Nesse campo, é mostrado os dados que foram inseridos para criar esse fechamento, como identificação do fechamento selecionado, datas e sua descrição.
                    </p>
                    <div className="icon-arrow-left">
                        <FiArrowUpLeft size={25} />
                    </div>
                </Modal.Body>
            );
            case 2: return (
                <Modal.Body>
                    <p className="description-text-info">
                        Abaixo, é mostrado as listas dos colaboradores e seus dados em detalhe.
                    </p>
                    <div className="icon-arrow-right">
                        <FiArrowDown size={25} />
                    </div>
                </Modal.Body>
            );
            case 3: return (
                <Modal.Body>
                    <p className="description-description-text-info">
                        Se necessário, o fechamento pode ser editado ou recalculado.
                        <br></br><br></br>
                        Atenção ao Recalcular o fechamento!
                        <br></br>
                        Os cálculos totais gerados anteriormente para o fechamento selecionado serão descartados!
                    </p>
                    <div className="icon-arrow-right">
                        <FiArrowUpRight size={25} />
                    </div>
                </Modal.Body>
            );
            default: return ""
        }
    }

    const handleNext = () => {
        if (isSteps !== 3)
            setIsSteps(isSteps + 1)
    }

    const handlePrevious = () => {
        if (isSteps !== 1)
            setIsSteps(isSteps - 1)
    }

    return (
        <>
            <button onClick={() => handleShow(true)} className="button-info">
                <FiHelpCircle size={17} />
            </button>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>O que é o Fechamento?</Modal.Title>
                </Modal.Header>

                {getStepsView(isSteps)}

                <Modal.Footer>
                    {isSteps !== 1 && (
                        <Button variant="outline-primary" onClick={handlePrevious}>
                            Voltar
                        </Button>
                    )}

                    {isSteps !== 3 && (
                        <Button variant="outline-primary" onClick={handleNext}>
                            Próximo
                        </Button>
                    )}

                    <Button variant="outline-danger" onClick={handleClose}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export { FechamentoViewHelpModal }
